(() => {
  "use strict";
  customElements.get("ticker-bar") ||
    customElements.define(
      "ticker-bar",
      class extends HTMLElement {
        constructor() {
          (super(),
            (this.activated = !1),
            (this.listening = !1),
            (this.activationObserver = null),
            (this.comparitor = null),
            (this.resizeEvent = window.theme.debounce(
              () => this.checkWidth(),
              100,
            )),
            (this.activateEvent = () => this.activate()),
            (this.sectionSelectEvent = (t) => {
              (t.target === this || t.target.contains?.(this)) &&
                this.activate();
            }));
        }
        connectedCallback() {
          if (
            ((this.autoplay = this.hasAttribute("data-autoplay")),
            (this.scale = this.querySelector("[data-ticker-scale]")),
            (this.text = this.querySelector("[data-ticker-text]")),
            this.scale && this.text)
          )
            return this.activated
              ? (this.bindGlobalListeners(), void this.checkWidth())
              : void (window.Shopify?.designMode ||
                (function (t) {
                  const e = t.getBoundingClientRect(),
                    i =
                      window.innerHeight ||
                      document.documentElement.clientHeight;
                  return e.top <= i + 800 && e.bottom >= -800;
                })(this)
                  ? this.activate()
                  : (this.addEventListener("focusin", this.activateEvent, {
                      once: !0,
                    }),
                    this.addEventListener("pointerdown", this.activateEvent, {
                      once: !0,
                    }),
                    document.addEventListener(
                      "shopify:section:select",
                      this.sectionSelectEvent,
                    ),
                    "IntersectionObserver" in window
                      ? ((this.activationObserver = new IntersectionObserver(
                          (t) => {
                            t.some((t) => t.isIntersecting) && this.activate();
                          },
                          { rootMargin: "800px 0px" },
                        )),
                        this.activationObserver.observe(this))
                      : this.activate()));
        }
        activate() {
          !this.activated &&
            this.scale &&
            this.text &&
            ((this.activated = !0),
            this.activationObserver?.disconnect(),
            (this.activationObserver = null),
            this.removeEventListener("focusin", this.activateEvent),
            this.removeEventListener("pointerdown", this.activateEvent),
            document.removeEventListener(
              "shopify:section:select",
              this.sectionSelectEvent,
            ),
            this.comparitor ||
              ((this.comparitor = this.text.cloneNode(!0)),
              this.comparitor.classList.add("ticker__comparitor"),
              this.comparitor.classList.remove("text-highlight-wrapper"),
              this.appendChild(this.comparitor)),
            this.scale.classList.remove("ticker--unloaded"),
            this.bindGlobalListeners(),
            requestAnimationFrame(() => {
              requestAnimationFrame(() => this.checkWidth());
            }),
            document.fonts?.ready &&
              document.fonts.ready.then(() => {
                this.isConnected && this.checkWidth();
              }));
        }
        bindGlobalListeners() {
          this.listening ||
            ((this.listening = !0),
            window.addEventListener("orientationchange", this.resizeEvent),
            document.addEventListener("theme:resize:width", this.resizeEvent));
        }
        checkWidth() {
          if (!this.activated || !this.comparitor) return;
          const t =
              2 * parseFloat(window.getComputedStyle(this).paddingLeft || 0),
            e = this.clientWidth - t;
          if (e < this.comparitor.clientWidth || this.autoplay) {
            let t = 1;
            if (this.autoplay) {
              const i = this.comparitor.clientWidth || this.text.clientWidth;
              t = i > 0 ? Math.max(Math.ceil((2 * e) / i), 2) - 1 : 11;
            }
            const i = t + 2,
              s = this.scale.querySelectorAll("[data-clone]").length;
            if (s < t || s > i) {
              (this.scale
                .querySelectorAll("[data-clone]")
                .forEach((t) => t.remove()),
                this.text.classList.remove("ticker--animated"),
                (this.reflow = this.text.offsetWidth),
                this.text.classList.add("ticker--animated"));
              for (let t = 0; t < i; t += 1) {
                const t = this.text.cloneNode(!0);
                (t.setAttribute("data-clone", ""), this.scale.appendChild(t));
              }
              this.autoplay &&
                this.querySelectorAll("[data-aos]").forEach((t) => {
                  t.classList.add("aos-animate");
                });
              const t =
                  (100 /
                    parseInt(
                      this.getAttribute("data-marquee-speed") || 100,
                      10,
                    )) *
                  1.63,
                e = (this.text.clientWidth / 100) * t;
              (this.scale.style.setProperty("--animation-time", e + "s"),
                this.animationPauseInitialized ||
                  ((this.animationPauseInitialized = !0),
                  this.tickerAnimationPause()));
            }
          } else
            (this.scale
              .querySelectorAll("[data-clone]")
              .forEach((t) => t.remove()),
              this.text.classList.remove("ticker--animated"));
        }
        tickerAnimationPause() {
          let t = 0,
            e = !1;
          (this.addEventListener("mouseenter", () => {
            ((e = !0),
              (t = setTimeout(() => {
                e &&
                  (this.querySelectorAll("[data-ticker-text]").forEach((t) => {
                    t.style.animationPlayState = "paused";
                  }),
                  clearTimeout(t));
              }, 500)));
          }),
            this.addEventListener("mouseleave", () => {
              ((e = !1),
                this.querySelectorAll("[data-ticker-text]").forEach((t) => {
                  t.style.animationPlayState = "running";
                }));
            }));
        }
        disconnectedCallback() {
          (this.activationObserver?.disconnect(),
            (this.activationObserver = null),
            this.removeEventListener("focusin", this.activateEvent),
            this.removeEventListener("pointerdown", this.activateEvent),
            document.removeEventListener(
              "shopify:section:select",
              this.sectionSelectEvent,
            ),
            window.removeEventListener("orientationchange", this.resizeEvent),
            document.removeEventListener(
              "theme:resize:width",
              this.resizeEvent,
            ),
            (this.listening = !1));
        }
      },
    );
})();
